// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/roboto-font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/roboto-font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/roboto-font/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/roboto-font/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/roboto-font/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'RobotoFont';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 100;
}
@font-face {
    font-family: 'RobotoFont';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    font-weight: 400;
}
@font-face {
    font-family: 'RobotoFont';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    font-weight: 600;
}

@font-face {
    font-family: 'RobotoFont';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    font-weight: 800;
}

@font-face {
    font-family: 'RobotoFont';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    font-weight: 900;
}

body {
    font-family: 'RobotoFont', sans-serif;
}

* {
    font-size: 14px;
    letter-spacing: 0.2px;
}

body small {
    font-size: 12px;
    color: #787f8e;
}`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,4CAA+C;IAC/C,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,4CAAiD;IACjD,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,4CAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,4CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,4CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB","sourcesContent":["@font-face {\n    font-family: 'RobotoFont';\n    src: url('assets/roboto-font/Roboto-Light.ttf');\n    font-weight: 100;\n}\n@font-face {\n    font-family: 'RobotoFont';\n    src: url('assets/roboto-font/Roboto-Regular.ttf');\n    font-weight: 400;\n}\n@font-face {\n    font-family: 'RobotoFont';\n    src: url('assets/roboto-font/Roboto-Medium.ttf');\n    font-weight: 600;\n}\n\n@font-face {\n    font-family: 'RobotoFont';\n    src: url('assets/roboto-font/Roboto-Bold.ttf');\n    font-weight: 800;\n}\n\n@font-face {\n    font-family: 'RobotoFont';\n    src: url('assets/roboto-font/Roboto-Black.ttf');\n    font-weight: 900;\n}\n\nbody {\n    font-family: 'RobotoFont', sans-serif;\n}\n\n* {\n    font-size: 14px;\n    letter-spacing: 0.2px;\n}\n\nbody small {\n    font-size: 12px;\n    color: #787f8e;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
